import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SPORTS = [['AL', 'A-League'], ['EPL', 'EPL'], ['AFL', 'AFL'], ['NRL', 'NRL']];

export default function AutoPickPanel() {
  const [users, setUsers] = useState([]);
  const [sport, setSport] = useState('AL');
  const [round, setRound] = useState('');
  const [userId, setUserId] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/admin/users`, { withCredentials: true })
      .then((r) => setUsers((r.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''))))
      .catch(() => setUsers([]));
  }, []);

  const apply = async () => {
    const rn = parseInt(round, 10);
    if (!rn || !userId) return toast.error('Pick a tipster and a round');
    const who = users.find((u) => u.user_id === userId)?.name || 'this tipster';
    if (!window.confirm(`Give ${who} away-team tips for every untipped ${sport} Round ${rn} game and lock their round?`)) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/admin/auto-pick`, { sport, round_number: rn, user_id: userId }, { withCredentials: true });
      toast.success(res.data.tips_added ? `${res.data.tips_added} away tips added for ${who}` : `${who} already has tips for every game in that round`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to apply away tips');
    }
    setBusy(false);
  };

  return (
    <div className="tipster-card space-y-3" data-testid="admin-auto-pick">
      <div>
        <h3 className="text-lg font-bold uppercase tracking-tight">Apply Away Tips</h3>
        <p className="text-sm text-gray-500 mt-1">For a tipster who missed a round: gives them the away team for every game they haven't tipped, then locks the round.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Select value={userId} onValueChange={setUserId}>
          <SelectTrigger className="w-52 bg-white" data-testid="auto-pick-user-select"><SelectValue placeholder="Tipster" /></SelectTrigger>
          <SelectContent className="bg-white max-h-72">
            {users.map((u) => <SelectItem key={u.user_id} value={u.user_id}>{u.name || u.email}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={sport} onValueChange={setSport}>
          <SelectTrigger className="w-32 bg-white" data-testid="auto-pick-sport-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            {SPORTS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
        <Input type="number" min="0" placeholder="Round" className="w-24" value={round}
          onChange={(e) => setRound(e.target.value)} data-testid="auto-pick-round-input" />
        <Button onClick={apply} disabled={busy} data-testid="auto-pick-apply-btn">{busy ? 'Applying…' : 'Apply away tips'}</Button>
      </div>
    </div>
  );
}
